import { render, staticRenderFns } from "./myTable.vue?vue&type=template&id=0b6073d7&scoped=true"
import script from "./myTable.vue?vue&type=script&lang=js"
export * from "./myTable.vue?vue&type=script&lang=js"
import style0 from "./myTable.vue?vue&type=style&index=0&id=0b6073d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6073d7",
  null
  
)

export default component.exports